/**
 * Sinaliza visualmente que o app está rodando em homolog.
 * Hardcoded em pt-BR — mensagem fixa de ambiente, não passa por i18n
 * (banner é operacional, não vai pra prod).
 */
export function EnvBanner() {
  const env = import.meta.env.VITE_ENV;
  if (env !== 'homolog') return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-yellow-400 text-[#1F3A6B] text-center py-1 text-sm font-semibold border-b border-yellow-600"
    >
      AMBIENTE DE HOMOLOGACAO &mdash; dados podem ser resetados a qualquer momento
    </div>
  );
}
